import { render, staticRenderFns } from "./AppBreadcrumbs.vue?vue&type=template&id=fcdb3fac&scoped=true"
import script from "./AppBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./AppBreadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./AppBreadcrumbs.vue?vue&type=style&index=0&id=fcdb3fac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcdb3fac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcdb3fac')) {
      api.createRecord('fcdb3fac', component.options)
    } else {
      api.reload('fcdb3fac', component.options)
    }
    module.hot.accept("./AppBreadcrumbs.vue?vue&type=template&id=fcdb3fac&scoped=true", function () {
      api.rerender('fcdb3fac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/app-breadcrumbs/AppBreadcrumbs.vue"
export default component.exports